/**
 * WelcomePopup Class
 */
export class WelcomePopup {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.scene = document.querySelector( containerEl );

		this.cookie = this.getCookie( 'welcomePopup' );

		this.addEvents();

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		const popup = document.querySelector( '.c-welcome-popup' );
		const close = document.querySelector( '.c-welcome-popup__close' );

		if ( close ) {

			close.addEventListener( 'click', ( ) => {

				if ( popup ) {

					popup.classList.remove( 'is-active' );

				}
				this.setCookie( 'welcomePopup', 'true' );

			} );

		}

		if ( ! this.cookie ) {

			if ( popup ) {

				popup.classList.add( 'is-active' );

			}

		}

	}

	/**
	 * Sets a cookie with the given name and value.
	 *
	 * @param {string} name - The name of the cookie.
	 * @param {string} value - The value of the cookie.
	 * @return {undefined} - This function does not return anything.
	 */
	setCookie = ( name, value ) => {

		const exdays = 100;
		const d = new Date();
		d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
		const expires = `expires=${ d.toUTCString() }`;

		document.cookie = `${ name }=${ value };${ expires };path=/`;

	}

	/**
	 * Retrieves the value of a cookie by name.
	 *
	 * @param {string} name - The name of the cookie to retrieve.
	 * @return {string} - The value of the cookie, or an empty string if the cookie does not exist.
	 */
	getCookie = ( name ) => {

		let cookieValue = '';
		const cookies = document.cookie.split( ';' );

		for ( let i = 0; i < cookies.length; i++ ) {

			let cookie = cookies[ i ];
			while ( cookie.charAt( 0 ) === ' ' ) {

				cookie = cookie.substring( 1 );

			}
			if ( cookie.indexOf( name ) === 0 ) {

				cookieValue = cookie.substring( name.length );

			}

		}

		return cookieValue;

	}

}
